import type { HttpErrorResponse, HttpEvent } from '@angular/common/http';
import {
  catchError,
  from,
  switchMap,
  throwError,
  type OperatorFunction,
  type Observable,
} from 'rxjs';

export function normalizeHttpError<T>(): OperatorFunction<HttpEvent<T>, HttpEvent<T>> {
  return source => source.pipe(catchError(handleHttpError));
}

function handleHttpError(err: HttpErrorResponse): Observable<never> {
  if (!(err.error instanceof Blob)) {
    return throwError(() => err);
  }

  return from(err.error.text()).pipe(switchMap(createErrorFromText(err)));
}

function createErrorFromText(originalError: HttpErrorResponse) {
  return (errorText: string) => {
    const normalizedError: HttpErrorResponse = {
      ...originalError,
      error: JSON.parse(errorText),
    };

    return throwError(() => normalizedError);
  };
}
